import React, { Component } from "react";
import { connect } from "react-redux";
import { userLogout } from "../../store/actions/auth/logout";
import { HOST } from '../../constants/index'
class Odjava extends Component {
  componentDidMount = () => {
    this.logout();
  };

  logout = () => {
    this.props.logout(this.redirectToLogin);
  };

  redirectToLogin = () => {
    if (HOST === "rr.fina.hr") {
      window.location.href = 'https://gov.hr/';
    } else {
      window.location.href = "https://iis2.globaldizajn.hr/egradani.gov.hr/"
    }
  };

  render() {
    return <div></div>;
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    logout: (redirect) =>
      dispatch(
        userLogout(
          redirect,
          "Odjavljeni ste iz aplikacije. Za nastavak rada odaberite prijavu!"
        )
      ),
  };
};

const mapStateToProps = (state) => {
  return {
    host: state.authentication.host
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Odjava);
